import { render } from "./SaveClientPayRate.vue?vue&type=template&id=3ada8c41"
import script from "./SaveClientPayRate.vue?vue&type=script&lang=js"
export * from "./SaveClientPayRate.vue?vue&type=script&lang=js"

import exportComponent from "/srv/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__